export function notifyWishlistChange() {
    window?.SF?.notifyWishlistChange?.();
}
